import React, { useState, useMemo, useEffect } from 'react';
import Loader from '@common/components/loader';

import { useParams } from 'react-router';
import CMSApi from '../../../services/cmsApi';
import CasinoAndLiveCasinoViewer from '../casinoAndLiveCasinoViewer';
import './style.scss';

export const CustomCasinoProvider = () => {
  const [data, setData] = useState({});
  const { providerId, gameId } = useParams();
  const routePath = `/casino-provider/${providerId}`;

  const loadGames = async () => {
    const { games } = await CMSApi.getCasinoGames({ category: 35, provider: [providerId] });
    return setData({ games });
  };

  const gameList = useMemo(() => data?.games, [data]);

  useEffect(() => { loadGames(); }, []);

  if (!data.games?.length) return <div className="loading"><Loader /></div>;

  return (
    <CasinoAndLiveCasinoViewer
      removeHeader
      categoryId={35}
      providers={[]}
      gameId={gameId}
      gamesData={{ list: gameList, total: gameList?.length }}
      routePath={routePath}
    />
  );
};
